import { Box, IconButton, Link, Menu, MenuItem, Tooltip } from '@material-ui/core';
import React, { cloneElement, isValidElement, useState } from 'react';
import { useTranslate } from 'react-admin';
import DownloadIcon from '@material-ui/icons/GetApp';
import { INVOICE_EXPORT_FILE_TYPE } from '../../../constant/invoice';
import resourceSlug from '../../../constant/resource-slug';

export default function ExportButton({ trigger, invoiceId }) {
  const t = useTranslate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {trigger && isValidElement(trigger) ? (
        cloneElement(trigger, {
          onClick: handleClick,
        })
      ) : (
        <Tooltip title={t('ra.action.export')}>
          <Box
            component={IconButton}
            aria-controls={open ? 'dropdown-menu' : undefined}
            aria-haspopup="true"
            onClick={handleClick}
            size="small"
            minWidth={30}
          >
            <DownloadIcon fontSize="small" />
          </Box>
        </Tooltip>
      )}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        getContentAnchorEl={null}
      >
        {Object.values(INVOICE_EXPORT_FILE_TYPE).map((type) => (
          <MenuItem
            key={type}
            component={Link}
            target="_blank"
            href={`api/${resourceSlug.INVOICE}/${invoiceId}/export?exportFileType=${type}`}
            onClick={(e) => {
              e.stopPropagation();
              handleClose();
            }}
          >
            {t(`common.invoiceExportFileType.${type}`)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
